import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "Niet gevonden", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, "De pagina die u heeft opgevraagd is niet gevonden.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Foutcode: 404", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_q_separator, { color: "primary" }),
          _hoisted_4,
          _hoisted_5
        ])
      ])
    ]),
    _: 1
  }))
}